const admissionTranslations = {
  es_CL: {
    title: '{name} ¡Ya casi! ',
    subtitle: 'Para finalizar el proceso de Admisión es necesario validar tu identidad, haciendo click en el botón:',
    validate: 'Validar identidad',
    documentationInfoCard:{
      title:'Documentación obligatoria',
      documentation:{
        rut: 'Frente y dorso de tu cédula',
        lem:'Licencia de Enseñanza Media (LEM)'
      },
      action:{
        text:'Subir documentación'
      },
      status:{
        pending:'Primero la documentación debe ser aceptada.',
        rejected:'Intentar Nuevamente',
        perceived:'Primero debes cargar la documentación obligatoria',
        approved:'Confirmar inscripción',
        signContract:'Firmar contrato'
      }
    },
    contractInfoCard:{
      documentation:'Revisa el documento y firma.',
      title:'Contrato de Servicios'
    },
    inscriptionInfoCard:{
      title:'Inscripción'
    },
    validateIdentity:{
      error:{
        title:'Ha ocurrido un error en el proceso, no se logró validar la identidad del usuario',
        titleEcert:'Ecert no logró validar la identidad del usuario'
      }
    }
},
  es_PE: {
      ecert: {
          approved:{
              description:'Ha Finalizado con éxito al proceso de Matrícula. Ya eres estudiante de IPP',
          },
          rejected:{
              title:'Ocurrio un error.',
              description:'Ha ocurrido un error en el proceso, favor comunícate con tu asesor para que pueda ayudarte'
          }
      },
  },
  es: {
    alert: {
      noteDoc: 'Asegúrate de cargar correctamente toda la documentación necesaria. En caso contrario, podría haber demoras en el proceso de trámites hasta que verifiquemos su validez.',
      noteSuccess: 'Vuelve a revisar el estado de tu trámite en 7 días hábiles.'
    },
    title: '¡Hola, {name}!',
    subtitle: 'Para continuar con la admisión necesitamos lo siguiente:',
    breadcrumbs: {
      title: 'Trámites',
    },
    documentation: {
      title: 'Documentación obligatoria',
      cardTitle1: 'Cédula de identidad',
      cardSubtitle1: 'Frente y dorso de tu cédula',
      cardTitle2: 'Licencia de Enseñanza Media',
      cardSubtitle2: 'Frente y dorso de tu licencia',
      cardTitle3: 'Documentación obligatoria de becas',
      cardSubtitle3: 'Frente y dorso de tu',
      cardTitle4: 'Documentación obligatoria de beneficios',
      cardSubtitle4: 'Frente y dorso de tu',
      sendDocumentation: 'Enviar Documentación',
      sendPhoto: 'Subir fotografía',
      help: '¿Tienes dudas sobre la documentación a presentar?',
      rules: 'Ver reglamento',
      status: 'Estado:',
      observation: 'Observación:',
      pending: 'Pendiente por validación externa',
      requiredDocumentation: 'Documentación obligatoria',
      requiredFields: 'Los documentos marcados con un * son obligatorios',
      revisedDocumentation: 'Documentación revisada:',
      scholarshipDocumentation: 'Documentación relacionada a tu beca',
      benefitDocumentation: 'Documentación relacionada a tu beneficio',
      replaceDocumentation: 'Debes reemplazar {n} documentos',
      requiredFields1: 'Los documentos marcados con un',
      requiredFields2: 'son obligatorios',
      statusDoc: 'Estado del documento:',
      nCertificate: 'N° de certificado',
      uploadSuccess: 'El documento se subió con éxito',
      uploadError: 'Intenta nuevamente subir tu documento',
    },
    photograph:{
      prePhotograph: 'Subir fotografías',
      postPhotograph: 'Ir a fotografías',
      title: 'Fotografías para titulación',
      description: 'Es una solicitud para que cargues cuatro fotografías que serán utilizadas para la titulación de tu carrera.',
      subtitle1: 'Asegúrate de leer bien todos los requisitos de fotografía antes de realizarla. Los documentos marcados con un ',
      subtitle2: ' son obligatorios',
      tecnic: 'Técnicos',
      tecnic1: '300 DPI',
      tecnic2: 'Formato JPG o PNG',
      tecnic3: 'Fotografía digital (NO escaneo)',
      titleSize: 'Tamaño: 6cm  de ancho x 9cm de alto (709px x 1063px)',
      titleSize1: 'Tamaño 709px x 1063px',
      minonSize: 'Tamaño: 3.5 cm  de ancho x  5cm de alto (415px x 591px)',
      minonSize1: 'Tamaño 415px x 591px',
      diplomaSize: 'Tamaño: 5cm  de ancho x  7cm de alto (591px x 827px)',
      diplomaSize1: 'Tamaño 591px x 827px',
      childSize: 'Tamaño: 2.5cm  de ancho x  3cm de alto (295px x 354px)',
      childSize1: 'Tamaño 295px x 354px',
      visual: 'Visuales',
      visual1: 'Enfoque de mitad de pecho hacia arriba',
      visual2: 'Fondo blanco',
      visual3: 'Sin filtros',
      visual4: 'Frente y orejas descubiertas',
      visual5: 'Sin accesorios que cubran la cara (lentes,gorros, piercings)',
      seeExample: 'Ver ejemplo'
    },
    careerChangeStep3: {
      dataSection: {
        header: 'Contrato de Servicios Educacionales'
      }
    },
    contract: {
      title: 'Contrato de Servicios Educacionales',
      subtitle: 'Lee el documento y firma a continuación. Ten en cuenta que se abrirá en una pestaña nueva para continuar el proceso.',
      sign: 'Firmar contrato'
    },
    ecert: {
      approved:{
        title:'¡BIENVENIDO!',
        description:'Ha Finalizado con éxito al proceso de Matrícula. Ya eres alumno de IPP',
      },
      rejected:{
        title:'Ocurrio un error.',
        description:'Ha ocurrido un error en el proceso, favor comunícate con tu asesor para que pueda ayudarte'
      }
    }
  },
  en: {
  }
}
export default admissionTranslations;
